
<section class="gym format">
  <div class="container">

    <div class="row">
      <div class="col-md-8 offset-md-2">

        <div class="format-sub-text mb-0">

          @if (selectedPage) {
            <div>
              @if (selectedPage.published === true) {
                <div >
                  <div [innerHTML]="selectedPage.content">
                  </div>
                </div>
              }
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</section>


